export const TableColumns = [
  {
    Header: "Id",
    accessor: "id",
  },
  {
    Header: "Table Name",
    accessor: "name",
  },
  {
    Header: "Location",
    accessor: "location",
  },
  {
    Header: "Capacity",
    accessor: "capacity",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Action",
    accessor: "actions",
  },
];

export const ReservationTableColumns = [
  {
    Header: "Id",
    accessor: "id",
  },
  {
    Header: "Guest",
    accessor: "guest",
  },
  {
    Header: "Table",
    accessor: "table",
  },
  {
    Header: "Order Items",
    accessor: "order_items",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Amount",
    accessor: "total_amount",
  },
  {
    Header: "Discount",
    accessor: "discount",
  },
  {
    Header: "Action",
    accessor: "actions",
    Cell: ({ value }) => (
      <div className="text-start">
        {value}
      </div>
    ),
  },
];
